/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfSecurityQuestions } from '../../models/data-page-of-security-questions';

export interface SecurityQuestionGetAll$Params {
  pageSize?: number;
  pageNumber?: number;
}

export function securityQuestionGetAll(http: HttpClient, rootUrl: string, params?: SecurityQuestionGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfSecurityQuestions>> {
  const rb = new RequestBuilder(rootUrl, securityQuestionGetAll.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('pageNumber', params.pageNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfSecurityQuestions>;
    })
  );
}

securityQuestionGetAll.PATH = '/securityQuestions/GetAll';
